module.exports = intLang;